var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-width:0.5px;}.cls-2{fill:#d68828;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2204",
    "data-name": "Group 2204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-1",
    d: "M54.09,58.24H19.43a3.39,3.39,0,0,1-2.65-1.35,5.26,5.26,0,0,1-.91-4.36,21.48,21.48,0,0,1,41.78,0,5.3,5.3,0,0,1-.91,4.36A3.39,3.39,0,0,1,54.09,58.24ZM36.76,38.38A19.09,19.09,0,0,0,18.15,53a2.9,2.9,0,0,0,.45,2.39,1.08,1.08,0,0,0,.83.47H54.09a1.06,1.06,0,0,0,.82-.47A2.9,2.9,0,0,0,55.37,53,19.09,19.09,0,0,0,36.76,38.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-2",
    cx: 36.5,
    cy: 19.01,
    r: 8.27
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountIcon);
export default __webpack_public_path__ + "static/media/myAccount-icon.14620661518761878a1ef1725b41656d.svg";
export { ForwardRef as ReactComponent };